(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3082],{

/***/ 33082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ productConfig; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./lib/getProductWithoutQuantity.js
var getProductWithoutQuantity = __webpack_require__(3506);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/wishlistSlice.js + 1 modules
var wishlistSlice = __webpack_require__(94650);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./seo/PopMechanicData.js
var PopMechanicData = __webpack_require__(76671);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/reach-dialog.mjs + 49 modules
var reach_dialog = __webpack_require__(42128);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-c7a4d7ce.esm.js + 2 modules
var index_c7a4d7ce_esm = __webpack_require__(11604);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(23157);
// EXTERNAL MODULE: ./hooks/use-window-size.js
var use_window_size = __webpack_require__(55876);
// EXTERNAL MODULE: ./assets/styles/vars.js
var vars = __webpack_require__(54935);
// EXTERNAL MODULE: ./components/productConfig/ProductConfig.module.scss
var ProductConfig_module = __webpack_require__(97354);
var ProductConfig_module_default = /*#__PURE__*/__webpack_require__.n(ProductConfig_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/productConfig/ProductOptions.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/anchor-is-valid */














var SizeModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9725).then(__webpack_require__.bind(__webpack_require__, 99725));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99725)];
    }
  }
});
var Option = index_c7a4d7ce_esm.c.Option,
    Menu = index_c7a4d7ce_esm.c.Menu;
var customStyles = {
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      paddingLeft: 16,
      fontFamily: vars/* default.fonts.futuraBook */.Z.fonts.futuraBook
    });
  },
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      flexWrap: 'nowrap',
      height: 44,
      borderRadius: 16
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderRadius: 16
    });
  }
};

var CustomMenu = function CustomMenu(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Menu, _objectSpread(_objectSpread({}, props), {}, {
    className: (ProductConfig_module_default()).menuComponent,
    children: props.children
  }));
};

var CustomMenuList = function CustomMenuList(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).scrollbar),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: props.children
    })
  });
};

var CustomMenuListModal = function CustomMenuListModal(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).scrollbar, (ProductConfig_module_default()).scrollbarModal),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: props.children
    })
  });
};

var useDelayUnmount = function useDelayUnmount(isMounted, delayTime) {
  var _useState = (0,react.useState)(false),
      shouldRender = _useState[0],
      setShouldRender = _useState[1];

  (0,react.useEffect)(function () {
    var timeoutId;

    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(function () {
        return setShouldRender(false);
      }, delayTime);
    }

    return function () {
      return clearTimeout(timeoutId);
    };
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
};

var touchStart = 0;
var touchDistance = 0;

var ProductOptions = function ProductOptions(_ref) {
  var options = _ref.options,
      setCurrentSlug = _ref.setCurrentSlug,
      currentSize = _ref.currentSize,
      setCurrentSize = _ref.setCurrentSize,
      isOpenSize = _ref.isOpenSize,
      setIsOpenSize = _ref.setIsOpenSize,
      sizes = _ref.sizes,
      noShowSizeTable = _ref.noShowSizeTable,
      addToCart = _ref.addToCart,
      addToWishlist = _ref.addToWishlist,
      isLook = _ref.isLook,
      actualPrice = _ref.actualPrice,
      setActualPrice = _ref.setActualPrice,
      setSizeLookModal = _ref.setSizeLookModal,
      sizeChoosenModalState = _ref.sizeChoosenModalState;
  var router = (0,next_router.useRouter)();
  var query = router.query;

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile;

  var _qs$parse = lib_default().parse(query),
      _qs$parse$variant = _qs$parse.variant,
      variant = _qs$parse$variant === void 0 ? null : _qs$parse$variant;

  var selectRef = (0,react.useRef)();
  var dialogRef = (0,react.useRef)();

  var _useState2 = (0,react.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var CustomOptionSize = function CustomOptionSize(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onTouchEnd: function onTouchEnd() {
        if (Math.abs(touchDistance) > 50) {
          touchDistance = 0;
          return;
        }

        touchDistance = 0;

        if (props.data.has) {
          handleInputChangeSize(props.data);
        }
      },
      onTouchMove: function onTouchMove(e) {
        touchDistance = e.touches[0].clientY - touchStart;
      },
      onTouchStart: function onTouchStart(e) {
        touchStart = e.touches[0].clientY;
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Option, _objectSpread(_objectSpread({}, props), {}, {
        className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).sizeOption, currentSize && currentSize.value === props.data.value && (ProductConfig_module_default()).selectedValue, !props.data.has && (ProductConfig_module_default()).sizeOptionDisabled),
        disabled: !props.data.has,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: props.data.label
        }), props.data.price && props.data.has && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductConfig_module_default()).sizeOptionPrice,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CurrencyPrice */.fE, {
            price: props.data.price,
            isDiscount: true
          })
        })]
      }))
    });
  };

  var handleCloseModal = (0,react.useCallback)(function () {
    setOpenModal(false);

    if (!isLook) {
      var _selectRef$current;

      (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.blur();
    }
  }, [isLook]);
  var handleOpenModal = (0,react.useCallback)(function () {
    if (isMobile && (isLook || true)) {
      setOpenModal(true);
    }
  }, [isMobile]);

  var _useState3 = (0,react.useState)([]),
      currentOptions = _useState3[0],
      setCurrentOptions = _useState3[1];

  var theme = (0,react.useMemo)(function () {
    return {
      colors: {
        primary: '#59896D',
        neutral0: '#fff',
        neutral20: '#F0F0F0',
        neutral50: '#BBBBBB'
      }
    };
  }, []);

  var handleInputChangeSize = function handleInputChangeSize(newValue) {
    setCurrentSize(newValue);
    setCurrentSlug(newValue.value);
    setSizeLookModal(newValue.value);
    setActualPrice(newValue === null || newValue === void 0 ? void 0 : newValue.price);

    if (isOpenSize) {
      addToCart(newValue);
    }

    if (openModal) {
      setIsOpenSize(false);
      handleCloseModal();
    }
  };

  var handleMenuClose = (0,react.useCallback)(function () {
    if (!openModal) {
      setIsOpenSize(false);
    }
  }, [setIsOpenSize, openModal]);
  (0,react.useEffect)(function () {
    if (options && options.length) {
      var newOptionsDate = options.map(function (_ref2) {
        var has = _ref2.has,
            price = _ref2.price,
            variant_id = _ref2.variant_id,
            name = _ref2.name;
        var itemSize = {
          has: has,
          price: price != actualPrice ? price : null,
          value: variant_id,
          label: name,
          isDisabled: !has
        };
        return itemSize;
      });
      setCurrentOptions(newOptionsDate);
      setCurrentSize(null);

      if (newOptionsDate.length === 1 && newOptionsDate[0].has) {
        handleInputChangeSize(newOptionsDate[0]);
      }
    }
  }, [options, variant, actualPrice]);
  (0,react.useEffect)(function () {
    if (variant && currentOptions && currentOptions.length) {
      currentOptions.map(function (option) {
        if (variant == option.value) {
          handleInputChangeSize(option);
        }
      });
    }
  }, [currentOptions, variant]);
  (0,react.useEffect)(function () {
    if (isLook && sizeChoosenModalState.length > 0 && currentOptions && currentOptions.length) {
      currentOptions.map(function (option) {
        if (sizeChoosenModalState.includes(option.value) && option.value !== (currentSize === null || currentSize === void 0 ? void 0 : currentSize.value)) {
          handleInputChangeSize(option);
        }
      });
    }
  }, [currentOptions, sizeChoosenModalState, isLook, currentSize]);
  (0,react.useEffect)(function () {
    if (isOpenSize && selectRef.current) {
      var _selectRef$current2;

      (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.focus();
    }
  }, [isOpenSize]);
  var shouldRenderChild = useDelayUnmount(openModal, 300);
  var mountedStyle = {
    animation: 'inAnimation 300ms ease-in'
  };
  var unmountedStyle = {
    animation: 'outAnimation 300ms ease-in'
  };
  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (openModal) {
        setIsOpenSize(false);
        handleCloseModal();
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return function () {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [openModal]);
  (0,react.useEffect)(function () {
    var _document$getElementB2;

    var handleClickSearch = function handleClickSearch(e) {
      if (openModal) {
        setIsOpenSize(false);
        handleCloseModal();
        setTimeout(function () {
          var _document, _document$getElementB;

          (_document = document) === null || _document === void 0 ? void 0 : (_document$getElementB = _document.getElementById('search-input')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
        }, 400);
      }
    };

    (_document$getElementB2 = document.getElementById('header-id')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.addEventListener('click', handleClickSearch);
    return function () {
      var _document$getElementB3;

      (_document$getElementB3 = document.getElementById('header-id')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.removeEventListener('click', handleClickSearch);
    };
  }, [openModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
      className: (ProductConfig_module_default()).select,
      theme: theme,
      openMenuOnFocus: isMobile ? isOpenSize : true,
      value: currentSize,
      name: "size",
      ref: selectRef,
      options: currentOptions,
      blurInputOnSelect: true,
      placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440",
      onChange: handleInputChangeSize,
      onMenuClose: handleMenuClose,
      onMenuOpen: handleOpenModal,
      isSearchable: false,
      styles: customStyles,
      noOptionsMessage: function noOptionsMessage() {
        return 'Нет вариантов';
      },
      components: {
        IndicatorSeparator: null,
        Option: CustomOptionSize,
        Menu: CustomMenu,
        MenuList: isLook ? CustomMenuListModal : CustomMenuList
      }
    }), shouldRenderChild && /*#__PURE__*/(0,jsx_runtime.jsx)(reach_dialog/* DialogOverlay */.t9, {
      isOpen: openModal,
      "aria-label": undefined,
      className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).dialogRoot),
      onDismiss: function onDismiss() {
        if (openModal) {
          setIsOpenSize(false);
          handleCloseModal();
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(reach_dialog/* DialogContent */.cZ, {
        className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).dialogContent),
        style: openModal ? mountedStyle : unmountedStyle,
        "aria-label": undefined,
        ref: dialogRef,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductConfig_module_default()).dialogHeader,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (ProductConfig_module_default()).dialogHeaderTitle,
            children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            onClick: function onClick() {
              if (openModal) {
                setIsOpenSize(false);
                handleCloseModal();
              }
            },
            className: (ProductConfig_module_default()).closeDialog,
            src: "/images/svg/close.svg",
            alt: "close"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (ProductConfig_module_default()).dialogList,
          children: currentOptions.map(function (option) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).sizeOption, !option.has && (ProductConfig_module_default()).sizeOptionDisabled, (currentSize === null || currentSize === void 0 ? void 0 : currentSize.value) === option.value && (ProductConfig_module_default()).sizeOptionActive),
              disabled: !option.has,
              onClick: function onClick() {
                if (option.has) {
                  handleInputChangeSize(option);
                }
              },
              onTouchEnd: function onTouchEnd() {
                if (Math.abs(touchDistance) > 50) {
                  touchDistance = 0;
                  return;
                }

                touchDistance = 0;

                if (option.has) {
                  handleInputChangeSize(option);
                }
              },
              onTouchMove: function onTouchMove(e) {
                touchDistance = e.touches[0].clientY - touchStart;
              },
              onTouchStart: function onTouchStart(e) {
                touchStart = e.touches[0].clientY;
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: option.label
              }), option.has && option.price && option.price !== actualPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (ProductConfig_module_default()).sizeOptionPrice,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CurrencyPrice */.fE, {
                  price: option.price,
                  isDiscount: true
                })
              })]
            }, option.value);
          })
        }), sizes && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductConfig_module_default()).dialogSizeTable,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SizeModal, {
            data: sizes
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var productConfig_ProductOptions = (ProductOptions);
;// CONCATENATED MODULE: ./components/productConfig/ProductConfig.js




function ProductConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductConfig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/anchor-is-valid */




















var AddToCart = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8945).then(__webpack_require__.bind(__webpack_require__, 58945));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(58945)];
    }
  }
});
var ProductConfig_SizeModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9725).then(__webpack_require__.bind(__webpack_require__, 99725));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99725)];
    }
  }
});

var ProductOptionsSliderModal = function ProductOptionsSliderModal(_ref) {
  var options = _ref.options,
      setCurrentSlug = _ref.setCurrentSlug,
      isLook = _ref.isLook,
      onLoadingError = _ref.onLoadingError;

  var handleClick = function handleClick(slug) {
    if (!isLook) {
      setCurrentSlug(slug, true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ProductConfig_module_default()).slider,
    children: options.filter(function (_ref2) {
      var active = _ref2.active;
      return isLook ? active : true;
    }).map(function (_ref3) {
      var _clsx;

      var slug = _ref3.slug,
          media = _ref3.media,
          hasSelectedConfig = _ref3.has,
          active = _ref3.active;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductConfig_module_default()).sliderItem,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return handleClick(slug);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (ProductConfig_module_default()).styledInactive, !hasSelectedConfig), (0,defineProperty/* default */.Z)(_clsx, (ProductConfig_module_default()).active, active), _clsx), (ProductConfig_module_default()).option, (ProductConfig_module_default()).styledImage),
          children: media && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Picture */.t, ProductConfig_objectSpread(ProductConfig_objectSpread({}, media), {}, {
            onLoadError: onLoadingError
          }))
        })
      }, slug);
    })
  });
};

var ProductOptionsSlider = function ProductOptionsSlider(_ref4) {
  var options = _ref4.options,
      setCurrentSlug = _ref4.setCurrentSlug,
      isLook = _ref4.isLook,
      onLoadingError = _ref4.onLoadingError;

  var handleClick = function handleClick(slug) {
    if (!isLook) {
      setCurrentSlug(slug, true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ProductConfig_module_default()).slider,
    children: options.map(function (_ref5) {
      var _model$slug, _clsx2;

      var media = _ref5.media,
          hasSelectedConfig = _ref5.has,
          active = _ref5.active,
          model = _ref5.model;

      var _getLinkProps = (0,getLinkProps/* default */.Z)({
        type: 'product',
        value: (_model$slug = model === null || model === void 0 ? void 0 : model.slug) !== null && _model$slug !== void 0 ? _model$slug : ''
      }),
          _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
          href = _getLinkProps2[0],
          as = _getLinkProps2[1];

      var Wrapper = active ? react.Fragment : (link_default());
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductConfig_module_default()).sliderItem,
        onClick: !active ? function () {
          return handleClick(model.slug);
        } : null,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, ProductConfig_objectSpread(ProductConfig_objectSpread({}, active ? null : {
          href: href,
          as: as,
          passHref: true,
          scroll: false
        }), {}, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)((_clsx2 = {}, (0,defineProperty/* default */.Z)(_clsx2, (ProductConfig_module_default()).styledInactive, !hasSelectedConfig), (0,defineProperty/* default */.Z)(_clsx2, (ProductConfig_module_default()).active, active), _clsx2), (ProductConfig_module_default()).option, (ProductConfig_module_default()).styledImage),
            children: media && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Picture */.t, ProductConfig_objectSpread(ProductConfig_objectSpread({}, media), {}, {
              onLoadError: onLoadingError
            }))
          })
        }))
      }, model.slug);
    })
  });
};

var ProductConfig = function ProductConfig(_ref6) {
  var _productInfo$indexCar3;

  var switchAttributes = _ref6.switchAttributes,
      _ref6$sizeChoosenModa = _ref6.sizeChoosenModalState,
      sizeChoosenModalState = _ref6$sizeChoosenModa === void 0 ? [] : _ref6$sizeChoosenModa,
      slug = _ref6.slug,
      currentSlug = _ref6.currentSlug,
      setCurrentSlug = _ref6.setCurrentSlug,
      _ref6$setSizeLookItem = _ref6.setSizeLookItem,
      setSizeLookItem = _ref6$setSizeLookItem === void 0 ? function () {
    return null;
  } : _ref6$setSizeLookItem,
      _ref6$setActiveImageN = _ref6.setActiveImageName,
      setActiveImageName = _ref6$setActiveImageN === void 0 ? function () {
    return null;
  } : _ref6$setActiveImageN,
      _ref6$setColorState = _ref6.setColorState,
      setColorState = _ref6$setColorState === void 0 ? null : _ref6$setColorState,
      _ref6$inStock = _ref6.inStock,
      inStock = _ref6$inStock === void 0 ? true : _ref6$inStock,
      data = _ref6.data,
      isModal = _ref6.isModal,
      isLook = _ref6.isLook,
      _ref6$noBucketButton = _ref6.noBucketButton,
      noBucketButton = _ref6$noBucketButton === void 0 ? false : _ref6$noBucketButton,
      _ref6$noShowSizeTable = _ref6.noShowSizeTable,
      noShowSizeTable = _ref6$noShowSizeTable === void 0 ? false : _ref6$noShowSizeTable,
      isProductPage = _ref6.isProductPage,
      children = _ref6.children,
      index = _ref6.index,
      _ref6$productInfo = _ref6.productInfo,
      productInfo = _ref6$productInfo === void 0 ? {} : _ref6$productInfo,
      setActualPrice = _ref6.setActualPrice,
      actualPrice = _ref6.actualPrice,
      modelId = _ref6.modelId,
      onLoadingError = _ref6.onLoadingError;
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);

  var _useSelector = (0,es/* useSelector */.v9)(store/* cartInfoSelector */.wg),
      ids = _useSelector.ids,
      count = _useSelector.count;

  var _useState = (0,react.useState)(false),
      sizeChosenModal = _useState[0],
      setSizeChosenModal = _useState[1];

  var _useState2 = (0,react.useState)(true),
      currentSize = _useState2[0],
      setCurrentSize = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isOpenSize = _useState3[0],
      setIsOpenSize = _useState3[1];

  var dispatch = (0,es/* useDispatch */.I0)();
  var wishlistIds = (0,es/* useSelector */.v9)(store/* wishlistIdsSelector */._7);
  var productId = switchAttributes.length > 0 && switchAttributes.some(function (attr) {
    return attr.name === 'Размер производителя';
  }) ? currentSize === null || currentSize === void 0 ? void 0 : currentSize.value : currentSlug;
  var productIdForCartBtn = isModal && !sizeChosenModal ? null : productId;
  (0,react.useEffect)(function () {
    (0,PopMechanicData/* setPageProductData */.sm)(data);
  }, [data]);
  var addToCart = (0,react.useCallback)(function (newValue) {
    var _productInfo$pageName, _productInfo$indexCar;

    // eslint-disable-next-line no-shadow
    var changeProductDataSize = function changeProductDataSize(data, size) {
      if (!size) return data;

      try {
        var attributes = [];
        attributes.push({
          value: size.label
        });

        for (var i = 0; i < data.attributes.length; i++) {
          var attribute = data.attributes[i];

          if (attribute.name === 'Основной цвет') {
            var value = attribute.options[0].name;
            attributes.push({
              value: value
            });
            break;
          }
        }

        return ProductConfig_objectSpread(ProductConfig_objectSpread({}, data), {}, {
          external_id: size.value,
          switchable_attributes: attributes
        });
      } catch (error) {
        console.warn('size value was not sent correctly');
        return data;
      }
    };

    var newData = changeProductDataSize(data, currentSize || newValue);
    Ecommerce/* default.viewItemList */.ZP.viewItemList([ProductConfig_objectSpread(ProductConfig_objectSpread({}, newData), {}, {
      quantity: 1
    })], currency, (_productInfo$pageName = productInfo === null || productInfo === void 0 ? void 0 : productInfo.pageName) !== null && _productInfo$pageName !== void 0 ? _productInfo$pageName : 'Страница товара', 'add_to_cart', (_productInfo$indexCar = productInfo === null || productInfo === void 0 ? void 0 : productInfo.indexCard) !== null && _productInfo$indexCar !== void 0 ? _productInfo$indexCar : 1);
  }, [currency, currentSize, data]);

  var putIntoCart = function putIntoCart(newValue) {
    var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');
    var isInCart = ids.includes(newValue.value);

    if (!isInCart) {
      dispatch((0,cartSlice/* updateCartIds */.U9)({
        ids: [].concat((0,toConsumableArray/* default */.Z)(ids), [newValue.value])
      }));
      dispatch((0,cartSlice/* updateCartCount */.N1)({
        count: count + 1
      }));
      dispatch((0,cartSlice/* createInCart */.p$)({
        mindboxDeviceUUID: mindboxDeviceUUID || '',
        id: newValue.value,
        meta: productInfo,
        quantity: 1,
        onSuccess: function onSuccess() {
          if (window && window.generalPixel) {
            window.generalPixel.postClick('a1');
          }

          addToCart(newValue);
        },
        onError: function onError() {
          dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
            forceRefresh: true
          }));
        }
      }));
    }
  };

  var putIntoWishlist = function putIntoWishlist(id) {
    var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');

    if (!wishlistIds.includes(id)) {
      dispatch((0,wishlistSlice/* createInWishlist */.JY)({
        id: id,
        mindboxDeviceUUID: mindboxDeviceUUID || '',
        onSuccess: function onSuccess() {
          var _productInfo$pageName2, _productInfo$indexCar2;

          dispatch((0,wishlistSlice/* updateWishlistIds */.Mu)({
            ids: [].concat((0,toConsumableArray/* default */.Z)(wishlistIds), [{
              product_id: id,
              model_id: modelId
            }])
          }));
          Ecommerce/* default.viewItemList */.ZP.viewItemList((0,getProductWithoutQuantity/* default */.Z)([data]), currency, (_productInfo$pageName2 = productInfo === null || productInfo === void 0 ? void 0 : productInfo.pageName) !== null && _productInfo$pageName2 !== void 0 ? _productInfo$pageName2 : 'Страница товара', 'add_to_wishlist', (_productInfo$indexCar2 = productInfo === null || productInfo === void 0 ? void 0 : productInfo.indexCard) !== null && _productInfo$indexCar2 !== void 0 ? _productInfo$indexCar2 : 1);
        }
      }));
    }
  };

  var isHasSizes = (0,react.useMemo)(function () {
    return switchAttributes.some(function (item) {
      return item.name === 'Размер производителя';
    });
  }, [switchAttributes]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ProductConfig_module_default()).config,
    children: [switchAttributes.map(function (_ref7) {
      var _options$find$name, _options$find;

      var view_type = _ref7.view_type,
          name = _ref7.name,
          _ref7$options = _ref7.options,
          options = _ref7$options === void 0 ? [] : _ref7$options,
          sizes = _ref7.sizes;

      if (!options || !options.length > 0) {
        return null;
      }

      var activeImageName = (_options$find$name = (_options$find = options.find(function (option) {
        return option.active;
      })) === null || _options$find === void 0 ? void 0 : _options$find.name) !== null && _options$find$name !== void 0 ? _options$find$name : null;
      var conditionImage = view_type === 'images' && activeImageName && !isLook;

      if (conditionImage && setColorState) {
        setColorState(activeImageName === null || activeImageName === void 0 ? void 0 : activeImageName.toLowerCase());
      }

      if (activeImageName && name === 'Основной цвет' && setActiveImageName) {
        setActiveImageName(activeImageName);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [isLook && !isHasSizes && isModal && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).propertySize, isModal && isLook && (ProductConfig_module_default()).propertyLookModal),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductConfig_module_default()).propertySizeNameBlock,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductConfig_module_default()).propertyName,
              children: "\u0420\u0430\u0437\u043C\u0435\u0440:"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductConfig_module_default()).propertySizeBlock,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductConfig_module_default()).withoutSize,
              children: "\u0411\u0435\u0437 \u0440\u0430\u0437\u043C\u0435\u0440\u0430"
            })
          })]
        }), conditionImage && /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
          className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).property, (ProductConfig_module_default()).noWrap),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("dt", {
            className: (ProductConfig_module_default()).propertyName,
            children: [name === 'Основной цвет' ? 'Цвет' : name, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
            children: activeImageName
          })]
        }), view_type === 'images' && !isLook && (isModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionsSliderModal, {
          isLook: isLook,
          setCurrentSlug: setCurrentSlug,
          options: options,
          onLoadingError: onLoadingError
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionsSlider, {
          options: options,
          isLook: isLook,
          setCurrentSlug: setCurrentSlug,
          onLoadingError: onLoadingError
        })), view_type === 'radio' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((ProductConfig_module_default()).propertySize, isModal && isLook && (ProductConfig_module_default()).propertyLookModal),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ProductConfig_module_default()).propertySizeNameBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ProductConfig_module_default()).propertyName,
              children: [name === 'Размер производителя' ? 'Размер' : name, ":"]
            }), sizes && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ProductConfig_module_default()).noShow, noShowSizeTable), isLook && (ProductConfig_module_default()).sizeTableLook, (ProductConfig_module_default()).propertySizeTable),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductConfig_SizeModal, {
                data: sizes
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductConfig_module_default()).propertySizeBlock,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(productConfig_ProductOptions, {
              isLook: isLook,
              isModal: isModal,
              index: index,
              options: options,
              setCurrentSlug: setCurrentSlug,
              setSizeChosenModal: setSizeChosenModal,
              setSizeLookModal: setSizeLookItem,
              currentSize: currentSize,
              setCurrentSize: setCurrentSize,
              setIsOpenSize: setIsOpenSize,
              isOpenSize: isOpenSize,
              productInfo: productInfo,
              addToCart: putIntoCart,
              addToWishlist: putIntoWishlist,
              setActualPrice: setActualPrice,
              sizes: sizes,
              noShowSizeTable: noShowSizeTable,
              actualPrice: actualPrice,
              sizeChoosenModalState: sizeChoosenModalState
            })
          }), sizes && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ProductConfig_module_default()).noShow, noShowSizeTable), isLook && (ProductConfig_module_default()).sizeTableLook, (ProductConfig_module_default()).propertySizeTableMobile),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductConfig_SizeModal, {
              data: sizes
            })
          })]
        })]
      }, name);
    }), isProductPage && children, !noBucketButton && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductConfig_module_default()).controls,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductConfig_module_default()).btnContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddToCart, {
          inStock: inStock,
          productInfo: productInfo,
          disabled: isModal ? !sizeChosenModal : false,
          productId: productIdForCartBtn,
          buttonProps: {
            classNames: {
              general: (ProductConfig_module_default()).button
            }
          },
          currentSize: currentSize,
          setIsOpenSize: setIsOpenSize,
          onSuccess: addToCart,
          isProductConfig: true,
          ids: ids
        })
      }), !isModal && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WishlistBtn */.yw, {
        product: ProductConfig_objectSpread(ProductConfig_objectSpread({}, data), {}, {
          external_id: currentSlug || slug
        }),
        border: true,
        index: (_productInfo$indexCar3 = productInfo === null || productInfo === void 0 ? void 0 : productInfo.indexCard) !== null && _productInfo$indexCar3 !== void 0 ? _productInfo$indexCar3 : 1,
        isProductConfig: true,
        isHideSizes: !isHasSizes,
        currentSize: currentSize,
        ids: wishlistIds,
        pageName: productInfo === null || productInfo === void 0 ? void 0 : productInfo.pageName
      })]
    })]
  });
};

/* harmony default export */ var productConfig_ProductConfig = (ProductConfig);
;// CONCATENATED MODULE: ./components/productConfig/index.js

/* harmony default export */ var productConfig = (productConfig_ProductConfig);

/***/ }),

/***/ 97354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"config":"ProductConfig_config__GfRpi","property":"ProductConfig_property__kqVSJ","btnContainer":"ProductConfig_btnContainer__qcUCk","controls":"ProductConfig_controls__WfOdE","button":"ProductConfig_button__Zy79d","sizeTable":"ProductConfig_sizeTable__sKRHb","noShow":"ProductConfig_noShow__OYGSI","sizeTableLook":"ProductConfig_sizeTableLook__thOYN","options":"ProductConfig_options__uPG5V","propertySize":"ProductConfig_propertySize__LU8U1","propertySizeNameBlock":"ProductConfig_propertySizeNameBlock__9JX29","propertySizeBlock":"ProductConfig_propertySizeBlock__g6S0R","select":"ProductConfig_select__5jDN5","sizeOption":"ProductConfig_sizeOption__kmJLw","sizeOptionPrice":"ProductConfig_sizeOptionPrice__rHehT","sizeOptionDisabled":"ProductConfig_sizeOptionDisabled__JIQu5","selectedValue":"ProductConfig_selectedValue___81Ka","propertySizeTable":"ProductConfig_propertySizeTable__TMSWm","withoutSize":"ProductConfig_withoutSize__dYWf9","propertySizeTableMobile":"ProductConfig_propertySizeTableMobile__zg9FZ","propertyLookModal":"ProductConfig_propertyLookModal__0gH2e","option":"ProductConfig_option__ymUze","active":"ProductConfig_active__1eTDz","isRadio":"ProductConfig_isRadio__ABxZH","styledImage":"ProductConfig_styledImage__62C_W","styledInactive":"ProductConfig_styledInactive__92UYA","name":"ProductConfig_name__5c6zY","slider":"ProductConfig_slider__QbGJh","propertyName":"ProductConfig_propertyName__5mWVr","dialogRoot":"ProductConfig_dialogRoot__8EPpG","dialogContent":"ProductConfig_dialogContent__66qC8","dialogHeader":"ProductConfig_dialogHeader__QziFs","dialogHeaderTitle":"ProductConfig_dialogHeaderTitle__bBrl6","closeDialog":"ProductConfig_closeDialog__6b_Mq","dialogList":"ProductConfig_dialogList___pmkJ","sizeOptionActive":"ProductConfig_sizeOptionActive__yxHfN","dialogSizeTable":"ProductConfig_dialogSizeTable__tAFUq","menuComponent":"ProductConfig_menuComponent__VeSjN","scrollbar":"ProductConfig_scrollbar__hmafY","scrollbarModal":"ProductConfig_scrollbarModal__nR_H4","noWrap":"ProductConfig_noWrap__niq_0","load":"ProductConfig_load__052yr"};

/***/ })

}]);